export default {
  inheritAttrs: false,
  props: {
    value: {
      type: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasFieldErrors () {
      return this.$cove.validation.hasFieldErrors(this.$vnode.key);
    }
  },
  methods: {
    focus () {
      this.$refs.proxy.focus();
    },
    trimToNull (value) {
      let result = value;
      if (typeof value === 'string')
      {
        result = value.trim();
        if (result === '')
        {
          result = null;
        }
      }

      return result;
    },
    mixinRequired (attributes) {
      if (this.required)
      {
        // vuetify, although undocumented, adds in the appropriate 'required' attribute to the input with this flag set
        // if that ever changes we may need to do it manually.
        attributes.required = true;
        attributes.label += ' *';
      }
    }
  }
};